import Head from "next/head";
import { Inter } from "next/font/google";
// import TopHeader from "@/components/TopHeader";
import Header from "@/components/Header";
import Projects from "@/components/Projects";
import Footer from "@/components/Footer";

const inter = Inter({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700", "800", "900"],
  variable: "--font-inter",
});

export default function ProjectsPage() {
  return (
    <div className={inter.variable}>
      <Head>
        <title>Projects - PISCESIA</title>
        <meta name="description" content="Explore PISCESIA's project implementations showcasing innovation and execution excellence in engineering and infrastructure development." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      {/* <TopHeader /> */}
      <Header />
      <Projects />
      <Footer />
    </div>
  );
}
